// Local storage key for language
export const LOCAL_STORAGE_KEY = 'lang' as const

export enum Language {
  TH = 'th',
  EN = 'en',
  MY = 'my',
  KM = 'km',
}

// Available languages in the system
export const AVAILABLE_LANGUAGES = Object.values(Language)

export const DEFAULT_LANGUAGE = Language.TH
